module.exports = {
	"articleTitle1": "Vanessa Carlton keeps things honest, relevant at The Ark ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "The Ark",
	"articleLink2": "https://www.michigandaily.com/section/arts/second-city-preview",
	"articleSnippet1": "Mar 6, 2017 ... Last Friday night at the Ark, it was clear what song Vanessa Carlton was going to \nopen with even before she started playing it. She said that she ...",
	"articleSnippet2": "Sep 13, 2016 ... On Sept. 16 and 17, Chicago's legendary improv comedy group The Second City \nwill visit Ann Arbor, performing at The Ark for the seventh ...",
	"totalMisc": 0,
	"articleTitle2": "The Second City brings improv laughs to The Ark ",
	"address": "316 S Main St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/gallery/public/galleryies/zqh.FEA_.ElephantRevival.11.11.15.04_1.jpg?itok=xgLSEY9v",
			"author": "Zoey Holmstrom",
			"caption": "Elephant Revival performs at The Ark in Ann Arbor on Wednesday."
		}
	],
	"position": {
		"lat": 42.2792,
		"lng": -83.749
	},
	"tips": [
		{
			"text": "Do try to come here at least once before leaving college. It's a great atmosphere for a concert.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "https://www.michigandaily.com/section/arts/vanessa-carlton-keeps-things-honest-relevant-ark",
	"categories": {
		"livemusic": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ark.json
// module id = 814
// module chunks = 0